<template src="./html/roi-calculator.html"></template>
<style lang="scss" src="./styles/main.scss"></style>

<script>
import formMixin from '../mixin';

export default {
  name: 'ROICalculator',
  mixins: [ formMixin ],
  computed: {
    total_learning_return: function() {
      // 260 = working days / year
      // 52 = working weeks / year

      let time_productivty = (this.data.learner_salary.replace(this.re, '') / 260) * (+this.data.number_days_reduced + +(this.data.increase_learner_productivity.replace(this.re, '') / 100)) * this.data.increase_knowledge_retention.replace(this.re, '') * this.data.number_learners.replace(this.re, '');

      let employee_retention = this.data.reduced_turnover_cost.replace(this.re, '') * this.data.number_learners.replace(this.re, '') * (this.data.increase_employee_engagement.replace(this.re, '') / 100);

      let operational_efficiency = this.data.learner_salary.replace(this.re, '') / 260 * this.data.days_reduced_work * 52;

      return time_productivty + employee_retention + operational_efficiency;
    },
    learning_investment: function() {
      return this.data.number_learners.replace(this.re, '') * this.data.var_cost_learner.replace(this.re, '') * this.data.number_days_program;
    },
    roi_of_learning: function() {
      return this.total_learning_return - this.learning_investment;
    }
  },
  methods: {
    initialState(){
      return {
        // ALL OF THESE ARE THE DEFAULT ROI VALUES
        number_learners: '100',
        var_cost_learner: '1000',
        number_days_program: '2',

        learner_salary: '50000',
        number_days_reduced: '1',
        increase_learner_productivity: '10',
        increase_knowledge_retention: '5',

        increase_employee_engagement: '30',
        reduced_turnover_cost: '25000',

        days_reduced_work: '4',

        reduction_energy_consumption: '90',
        reduced_co2_emissions: '85',
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ROICalculator.vue